import type { ComponentType } from 'react';
import { UnauthorizedLayoutSummitBanner } from './UnauthorizedLayoutSummitBanner';

const PROMO_BLOCKS: Record<string, ComponentType> = {
  '01': UnauthorizedLayoutSummitBanner,
};

export { PROMO_BLOCKS };
